import cart from 'lib/cart'

export const actions = {
  getCart ({ commit, state }, payload) {
    commit('setLoading', true)

    return cart
      .get()
      .then(data => {
        commit('refreshCart', data)
      })
  },

  updateItemQuantity ({commit, state}, { quantity, id, key }) {
    if (!id) {
      return
    }

    commit('setLoading', true)

    return cart
      .update(key, { quantity })
      .then(data => {
        commit('refreshCart', data)
        cart.getState()
      })
  },

  updateItemsQuantity ({commit, state}, items) {
    if (!items) {
      return
    }
    commit('setLoading', true)

    return cart
      .updateBundles(items)
      .then(data => {
        commit('refreshCart', data)
        cart.getState()
      })
  },

  addToCart ({dispatch, state}, { id, quantity }) {
    const { items } = state.app.cart

    // Adds the requested `quantity` to the current item.quantity
    const item = items.find(i => i.variant_id === id)
    const totalQuantity = item
      ? item.quantity + quantity
      : quantity

    return dispatch('updateItemQuantity', { key: item.key, id, quantity: totalQuantity })
  },

  trackAddToCart ({dispatch, state}, { product, id }) {
    const variant = product.variants.find(({id: _id}) => _id === id)

    fbq && fbq('track', 'AddToCart', {
      value: (Number(variant.price) / 100),
      currency: 'USD',
      content_name: variant.name,
      content_type: 'product',
      content_ids: [id]
    })
  },

  async updateGiftMessage ({ commit }, message) {
    commit('updateGiftMessage', message)
    commit('giftMessageState', true)
  },

  async saveGiftMessage ({ commit, getters }) {
    commit('setLoading', true)
    try {
      await cart.updateNote(getters.giftMessage)
      commit('giftMessageState', false)
    } catch (error) {
      console.log(error)
    } finally {
      commit('setLoading', false)
    }
  }
}
